module.exports = __webpack_public_path__ + "static/media/goal6.7f1c8b8f.svg";